import * as React from "react";
import classNames from "classnames";
import Icon, { TIconNames } from "../icons/icon";

export interface IIconLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    className?: string;
    iconId?: TIconNames;
    ariaLabel?: string;
}

const IconLink: React.FC<IIconLinkProps> = props => {
    const baseClass = "icon-link";
    const componentClasses = classNames(baseClass, props.className);
    const iconWrapperClasses = `${baseClass}--icon-wrapper`;
    const iconClasses = `${baseClass}--icon`;
    const textClasses = `${baseClass}--text`;

    return (
        <a
            aria-label={props.ariaLabel}
            href={props.href}
            className={componentClasses}
            download={props.download}
            target={props.target}
        >
            {props.iconId && (
                <span className={iconWrapperClasses}>
                    <Icon iconId={props.iconId} className={iconClasses} />
                </span>
            )}
            {props.children ? <span className={textClasses}>{props.children}</span> : null}
        </a>
    );
};
export default IconLink;
